import message from './message';
import companyMessage from './company-message';
import giftCard from './gift-card';

export default { message, companyMessage, giftCard };
